import React, { MouseEvent } from 'react';
import './ToggleSwitch.pcss';
import classnames from 'classnames';

type Props = {
  isOn: boolean;
  leftSwitchText?: string;
  rightSwitchtext?: string;
  handleToggle: (event: MouseEvent<HTMLUListElement>) => void;
  classes?: {
    container?: string;
    trigger?: string;
    activeTrigger?: string;
  };
};

export const ToggleSwitch = ({
  classes,
  isOn,
  handleToggle,
  leftSwitchText,
  rightSwitchtext,
}: Props) => {
  return (
    <ul
      className={classnames(
        classes?.container,
        'toggle-switch',
        'toggle-switch--tabs',
        {
          'toggle-switch--trigger--slide': isOn,
        },
      )}
      onClick={handleToggle}
    >
      <li
        className={classnames(
          classes?.trigger,
          'toggle-switch',
          'toggle-switch--trigger',
          {
            [classes?.activeTrigger || 'toggle-switch--trigger--active']: !isOn,
          },
        )}
      >
        {leftSwitchText}
      </li>
      <li
        className={classnames(
          classes?.trigger,
          'toggle-switch',
          'toggle-switch--trigger',
          {
            [classes?.activeTrigger || 'toggle-switch--trigger--active']: isOn,
          },
        )}
      >
        {rightSwitchtext}
      </li>
    </ul>
  );
};
